import { render, staticRenderFns } from "./KardexCosts.vue?vue&type=template&id=b20d45aa&scoped=true&"
import script from "./KardexCosts.vue?vue&type=script&lang=js&"
export * from "./KardexCosts.vue?vue&type=script&lang=js&"
import style0 from "./KardexCosts.vue?vue&type=style&index=0&id=b20d45aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20d45aa",
  null
  
)

export default component.exports